module.exports = __webpack_public_path__ + "img/14@3x.3d410ad1.png";